<template>
  <v-dialog v-model="visible" max-width="600px">
    <v-card>
      <v-toolbar color="#f9f9f9">
        <v-toolbar-title>投保须知</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="visible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-text>
        <p>1.投保人通过合法途径获得团体授权，向保险人投保本险种，所有投保操作和内容已获得认可，所有被保险人均为与投保单位有劳动关系的劳动者，该产品的保障内容以及保险金额已向被保险人进行了明确说明，并征得其同意。</p>
        <p>2.投保人已就保险事宜与全部被保险人进行了宣导和沟通：</p>
        <ul style="list-style-type:decimal">
          <li>（1）凡参与该保险的全部被保险人均符合险种条款所约定（包括但不限于责任免除、投保人被保险人义务、保险金申请与给付等）的投保条件，并了解保障内容且同意由投保人统一办理投保事项；</li>
          <li>（2）同意贵司为本保险及与本保险之相关服务的目的收集被保险人的个人资料，无论该资料是从本投保申请或其他地方所获取。同意并理解贵公司为提升保险服务质量，可能会与第三方机构、组织或个人合作，此类合作可能需要使用被保险人的个人资料。在此理解下，被保险人同意并授权贵公司及与贵公司存在合作关系的机构、组织或个人将收集的本人的个人资料用于：A.该保险的投保审核；B.该保险的理赔；C.提供与该保险有关之服务；D.与被保险人联络。投保人已认真阅读并正确理解条款和投保须知的所有内容，并接受上述内容，同意以此作为订立保险合同的依据。</li>
        </ul>
        <p>3.本产品投保填写以及所附的被保险人清单中的各项事实均属实，并作为本保险合同的组成部分，如有隐瞒或不实告知，投保人愿承担由此带来的法律后果，保险人有权解除保险合同，对于合同解除前发生的任何事故，保险人可不承担任何责任。</p>
        <p>4..投保人同意你公司通过手机（包括手机短信）、E-mail适时提供保险信息服务。</p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  }
};
</script>

<style>
</style>
